type IconProps = {
  className?: string
}

export function PendingTasksHeaderIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <g transform='translate(0.66665 1)'>
        <path
          d='M5 6.33333L7 8.33333L13.6667 1.66667M13 7V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V2.33333C1 1.97971 1.14048 1.64057 1.39052 1.39052C1.64057 1.14048 1.97971 1 2.33333 1H9.66667'
          stroke='#A16207'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function ContractsRenewalHeaderIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <g transform='translate(1.66665 0.33335)'>
        <path
          d='M11.6667 5L7.66667 1H2.33333C1.97971 1 1.64057 1.14048 1.39052 1.39052C1.14048 1.64057 1 1.97971 1 2.33333V13C1 13.3536 1.14048 13.6928 1.39052 13.9428C1.64057 14.1929 1.97971 14.3333 2.33333 14.3333H10.3333C10.687 14.3333 11.0261 14.1929 11.2761 13.9428C11.5262 13.6928 11.6667 13.3536 11.6667 13V5ZM7.66667 1V5H11.6667M6.33333 11.6667V7.66667M4.33333 9.66667H8.33333'
          stroke='#FF5A1F'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function TaskItemIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <g transform='translate(1.86665 0.53335)'>
        <path
          d='M8.8 2.13333H10.1333C10.487 2.13333 10.8261 2.27381 11.0761 2.52386C11.3262 2.77391 11.4667 3.11304 11.4667 3.46667V12.8C11.4667 13.1536 11.3262 13.4928 11.0761 13.7428C10.8261 13.9929 10.487 14.1333 10.1333 14.1333H2.13333C1.77971 14.1333 1.44057 13.9929 1.19052 13.7428C0.940476 13.4928 0.8 13.1536 0.8 12.8V3.46667C0.8 3.11304 0.940476 2.77391 1.19052 2.52386C1.44057 2.27381 1.77971 2.13333 2.13333 2.13333H3.46667M4.13333 0.8H8.13333C8.50152 0.8 8.8 1.09848 8.8 1.46667V2.8C8.8 3.16819 8.50152 3.46667 8.13333 3.46667H4.13333C3.76514 3.46667 3.46667 3.16819 3.46667 2.8V1.46667C3.46667 1.09848 3.76514 0.8 4.13333 0.8Z'
          stroke='#272C36'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function ContractItemIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <g transform='translate(1.86665 0.53335)'>
        <path
          d='M11.4667 4.8L7.46667 0.8H2.13333C1.77971 0.8 1.44057 0.940476 1.19052 1.19052C0.940476 1.44057 0.8 1.77971 0.8 2.13333V12.8C0.8 13.1536 0.940476 13.4928 1.19052 13.7428C1.44057 13.9929 1.77971 14.1333 2.13333 14.1333H10.1333C10.487 14.1333 10.8261 13.9929 11.0761 13.7428C11.3262 13.4928 11.4667 13.1536 11.4667 12.8V4.8ZM7.46667 0.8V4.8H11.4667M8.8 8.13333H3.46667M8.8 10.8H3.46667M4.8 5.46667H3.46667'
          stroke='#272C36'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function DashboardListArrowIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <g transform='translate(2.53335 2.53335)'>
        <path
          d='M0.8 5.46667H10.1333M5.46667 10.1333L10.1333 5.46667L5.46667 0.8'
          stroke='#FF5A1F'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function DashboardListDotIcon({ className }: IconProps) {
  return (
    <svg
      width='4'
      height='4'
      viewBox='0 0 4 4'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <circle cx='2' cy='2' r='2' fill='#8F95A6' />
    </svg>
  )
}
